// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interface-container {
  width: 39vw;
  height: 100%;
  overflow: auto;
  padding: 0 30px 60px 20px;
  max-width: 500px;
  background-color: #ffffff;
  z-index: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

.interface-container::-webkit-scrollbar {
  display: none;
}

.interface {
  width: 100%;
  overflow: scroll;
}

.interface::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/interface/interface.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,WCUgB;EDThB,YAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;AADF","sourcesContent":["@use \"../../styles/variables\" as vars;\n\n.interface-container {\n  width: vars.$width-interface;\n  height: 100%;\n  overflow: auto;\n  padding: 0 30px 60px 20px;\n  max-width: 500px;\n  background-color: vars.$white-color;\n  z-index: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n}\n\n.interface-container::-webkit-scrollbar {\n  display: none;\n}\n\n.interface {\n  width: 100%;\n  overflow: scroll;\n}\n\n.interface::-webkit-scrollbar {\n  display: none;\n}\n","$primary-color: #629A33;\n$secondary-color: #6c757d;\n$font-size-base: 16px;\n$second-color: #629A33;\n$second-color-1: #06aeef;\n$shadow-color: #47659314;\n$black-color:  #1A1A1A;\n$black-color-second: #3A3A3C;\n$white-color: #ffffff;\n$red-color: #ff214a;\n\n$margin-top-title-option: 10px;\n$padding-vertical-group-inputs: 20px;\n$width-interface: 39vw;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
